// TODO: turn this into a react component perhaps,
// or redux logic or something
// TODO: generalize this instead of having specific cases

let onReadEmail = null
let onReadOrderFormId = null
let onReadBarcode = null

export function setOnReadEmail(handler) {
  onReadEmail = handler
}

export function setOnReadOrderFormId(handler) {
  onReadOrderFormId = handler
}

export function setOnReadBarcode(handler) {
  onReadBarcode = handler
}

export function handleReadQRCode(value) {
  const isEmail = value.includes('@')
  const isOrderFormId = !isEmail && value.length === 32
  const isBarcode = !isEmail && !isOrderFormId
  if (isEmail && onReadEmail) {
    onReadEmail(value)
  } else if (isOrderFormId && onReadOrderFormId) {
    onReadOrderFormId(value)
  } else if (isBarcode && onReadBarcode) {
    onReadBarcode(value)
  }
}

export default {
  setOnReadEmail,
  setOnReadOrderFormId,
  setOnReadBarcode,
  handleReadQRCode,
}
